<template>
  <div class="login-container">
    <el-card class="box-card">
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" autocomplete="on" label-position="left">
        <div class="title-container">
          <h3 class="title">郑州波特乐电气有限公司</h3>
        </div>

        <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
          <el-input class="el-input1"
              ref="username"
              v-model="loginForm.username"
              placeholder="用户名"
              name="username"
              type="text"
              tabindex="1"
              autocomplete="on"
          />
        </el-form-item>

        <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
          <el-form-item prop="password">
            <span class="svg-container">
              <svg-icon icon-class="password" />
            </span>
            <el-input class="el-input1"
                :key="passwordType"
                ref="password"
                v-model="loginForm.password"
                :type="passwordType"
                placeholder="密码"
                name="password"
                tabindex="2"
                autocomplete="on"
                @keyup.native="checkCapslock"
                @blur="capsTooltip = false"
            />
            <span class="show-pwd" @click="showPwd">
              <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
            </span>
          </el-form-item>
        </el-tooltip>

        <el-row :span="24">
          <el-col :span="13">
            <el-form-item prop="verify_code">
              <span class="svg-container">
                <svg-icon icon-class="verify-code" />
              </span>
              <el-input class="el-input2"
                  ref="verify_code"
                  v-model="loginForm.verify_code"
                  placeholder="验证码"
                  name="verify_code"
                  type="text"
                  tabindex="3"
                  autocomplete="on"
                        @keyup.enter.native="handleLogin"
              />
        </el-form-item>
          </el-col>

          <el-col :span="11">

              <div class="login-code" @click="refreshCode">
                <!--验证码组件-->
                <identify :identifyCode="identifyCode"></identify>
              </div>

          </el-col>
        </el-row>

        <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="handleLogin">登录</el-button>
      </el-form>
    </el-card>
    <a style="left:42%;top:96%; position: absolute; text-decoration: none; color: black;" rel="nofollow" href="https://beian.miit.gov.cn/">郑州波特乐电气有限公司    |	豫ICP备18032087号-1</a>
  </div>

</template>

<script>
import Identify from 'src/components/Identify'

export default {
  name: "Login",
  components: { Identify },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('The password can not be less than 6 digits'))
      } else {
        callback()
      }
    }

    return {
      loginForm: {
        username: '',
        password: '',
        verify_code:''
      },
      loginRules: {
        username: [{ required: true, message: "请输入用户名",trigger: 'blur' }],
        password: [{ required: true, message: "请输入密码",trigger: 'blur', validator: validatePassword }],
        verify_code: [{ required: true, message: "请输入验证码",trigger: 'blur' }],
      },
      // 验证码
      identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz",
      identifyCode: "",
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {}
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        //console.log("route:"+route)
        const query = route.query
        if (query) {
          //this.redirect = query.redirect
          this.redirect = '/'
          //console.log("path:"+this.redirect)
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  created() {
    // window.addEventListener('storage', this.afterQRScan)
  },
  mounted() {
    //let params = { userName: 'bote_admin', password: 'bote19992020'}
    /*login(params).then(
        res =>{
          console.log(res, '这是响应的结果')
        }
    )*/
    if (this.loginForm.username === '') {
      this.$refs.username.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    }

    // 初始化验证码
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && (key >= 'A' && key <= 'Z')
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      if (
          this.loginForm.verify_code.toLowerCase() !== this.identifyCode.toLowerCase()
      ) {
        this.$message.error("验证码错误");
        // 刷新验证码
        this.refreshCode();
        return;
      }

      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('user/login', this.loginForm)
              .then(() => {
                this.$router.push({ path: this.redirect || '/', query: this.otherQuery })
                this.loading = false
              })
              .catch(() => {
                this.loading = false
              })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    // 设置验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    // 制造验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
            this.randomNums(0, this.identifyCodes.length)
            ];
      }
    },
    // 验证码随机
    randomNums(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    }
    // afterQRScan() {
    //   if (e.key === 'x-admin-oauth-code') {
    //     const code = getQueryObject(e.newValue)
    //     const codeMap = {
    //       wechat: 'code',
    //       tencent: 'code'
    //     }
    //     const type = codeMap[this.auth_type]
    //     const codeName = code[type]
    //     if (codeName) {
    //       this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
    //         this.$router.push({ path: this.redirect || '/' })
    //       })
    //     } else {
    //       alert('第三方登录失败')
    //     }
    //   }
    // }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg:#fff;
$fore_color:#303133;
$cursor: #409EFF;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input1 {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0;
      -webkit-appearance: none;
      border-radius: 0;
      font-size: 18px;
      color: $fore_color;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-input2 {
    display: inline-block;
    height: 47px;
    width: 65%;

    input {
      background: transparent;
      border: 0;
      -webkit-appearance: none;
      border-radius: 0;
      font-size: 20px;
      color: $fore_color;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-button {
    font-size: 25px;
    font-weight: 400;
    letter-spacing: 20px;
  }

  .el-form-item {
    border: 1px solid rgba(0, 0, 0, 0.3);
    background: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    color: #454545;
    margin-bottom:35px;
  }
}
</style>

<style scoped lang="scss">

.login-container {
  min-height: 100%;
  width: 100%;
  background-image:url('../../assets/login/loginbg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;

  .box-card {
    width: 452px;
    height: 500px;
    border-radius: 16px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);

    .login-form {
      position: relative;

      max-width: 100%;
      padding: 20px 25px 0;
      margin: 0 auto;
      overflow: hidden;
    }

    .tips {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }

    .svg-container {
      padding: 6px 5px 6px 5px;

      vertical-align: middle;
      width: 32px;
      display: inline-block;
    }

    .title-container {
      position: relative;

      .title {
        font-size: 26px;

        margin: 0px auto 40px auto;
        text-align: center;
        font-weight: bold;
      }
    }

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;

      cursor: pointer;
      user-select: none;
    }

    .thirdparty-button {
      position: absolute;
      right: 0;
      bottom: 6px;
    }

    @media only screen and (max-width: 470px) {
      .thirdparty-button {
        display: none;
      }
    }

  }
}
</style>
